<template>
  <div class="c-spacer" :style="styleObject">
    <!--  -->
  </div>
</template>

<script>
export default {
  name: 'spacer',

  props: {
    size: [Number, String],
  },

  computed: {
    styleObject() {
      return {
        height: `${this.size}px` || '48px',
      };
    },
  },
};
</script>

<style lang="scss">
.c-spacer {
  //
}
</style>
